import { createSelector } from '@ngrx/store';

import { HomeProject } from '@models/swagger';
import { State } from './reducer';
import { selectPostComeroundProjectState } from '../selectors';

export const getData = createSelector(selectPostComeroundProjectState, (state: State) => state.data);

export const getError = createSelector(selectPostComeroundProjectState, (state: State) => state.error);

export const getLoading = createSelector(selectPostComeroundProjectState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: HomeProject) => T) =>
  createSelector(selectPostComeroundProjectState, (state: State) => fn(state.data));
